// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_i4-6";
export var emphasizeQuantity = "_i4-3";
export var flatBottomCorners = "_i4-5";
export var productImage = "_i4-0";
export var quantityContainer = "_i4-2";
export var tooltip = "_i4-1";
export var wrapAndEllipsesOverflow = "_i4-4";